import { Injectable } from '@angular/core';
import { ApiCacheService } from './api-cache.service';

@Injectable({
  providedIn: 'root'
})
export class CacheManagerService {
  constructor(private apiCacheService: ApiCacheService) {
    // Clear cache on service initialization (app startup)
    this.clearCacheOnStartup();
  }

  private clearCacheOnStartup(): void {
    this.apiCacheService.clear();
    console.log('Cache cleared on application startup');
    
    // Store the current timestamp in localStorage to track app sessions
    localStorage.setItem('appSessionStartTime', Date.now().toString());
  }

  /**
   * Check if the app has been refreshed/reloaded
   * Can be called from app component to detect refresh
   */
  public checkAndHandleAppRefresh(): void {
    const lastSessionTime = localStorage.getItem('appSessionStartTime');
    const currentTime = Date.now().toString();
    
    // Update the session time
    localStorage.setItem('appSessionStartTime', currentTime);
    
    // If there was a previous session and it's not the same as current,
    // we've likely refreshed the page
    if (lastSessionTime && lastSessionTime !== currentTime) {
      this.apiCacheService.clear();
      console.log('Cache cleared on application refresh');
    }
  }
} 